import { ServiceProviderService } from './../../../services/service-provider.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RoleType } from 'src/app/enum/role-type';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserdataService } from 'src/app/services/userdata.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserSessionService } from 'src/app/services/usersession.service';
import * as _ from "lodash";
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import Swal from 'sweetalert2';
import { MatDatepicker } from '@angular/material/datepicker';
import { InputformatServiceService } from 'src/app/services/inputformat-service.service';
import { BillingService } from 'src/app/services/billing.service';
import { PaySoftBankList } from 'src/app/enum/PaySoftBankList';
import { GraylogNotificationConfigurationService } from 'src/app/services/graylog-notification-configuration.service';
import { ProfileDetailService } from 'src/app/services/profile-detail.service';
import { firstValueFrom } from 'rxjs';


@Component({
    selector: 'app-customer-ammendment',
    templateUrl: './customer-ammendment.component.html',
    styleUrls: ['./customer-ammendment.component.scss']
})
export class CustomerAmmendmentComponent implements OnInit {
    roleTypeEnum = RoleType;
    sessionDataString: any;
    selectedIndex: number;
    form: FormGroup;
    customerDetails: FormGroup;
    amendAddressForm: FormGroup;
    accountVerificationForm: FormGroup;
    billingInfoFormGroup: FormGroup;
    maxDate: any;
    minDate: any;
    @ViewChild('dateOfBirth') dateOfBirthPicker: MatDatepicker<Date>;
    amendcustomer: boolean = false;
    amendaddress: boolean = false;
    mail: any;
    roll: any;
    bill: any;
    formData: any;
    filteredList: any;
    filteredList2: any;
    move: boolean = false;
    billlingInformation: boolean = false;
    BankList: any = [];
    filterBankList: any = [];
    AccountTypeList: any = [];
    filterAccountTypeList: any = [];
    bankaccountmode: number;
    cusdetails: any;

    constructor(

        private navigationService: NavigationService,
        private toastr: NotificationService,
        private _formBuilder: FormBuilder,
        private UserdataService: UserdataService,
        private sessionService: UserSessionService,
        private InputformatService: InputformatServiceService,
        private _billingService: BillingService,
        private LookupDataServiceService: LookupDataServiceService,
        private grayLogService: GraylogNotificationConfigurationService,
        private ProfileDetailService: ProfileDetailService
    ) {

    }

    ngOnInit() {
        this.sessionDataString = JSON.parse(
            localStorage.getItem(this.sessionService.localStorageSessionKey)
        );
        this.initForm();
        this.getminyears();
        this.getGrayLogNotification()

        this.BankList = Object.entries(PaySoftBankList).map(([value, key]) => ({ key, value }));
        this.filterBankList = this.BankList.slice();
    }
    getGrayLogNotification() {
        this.grayLogService.GraylogNotificationConfiguration().subscribe((res) => {
            res.forEach(item => {
                switch (item.key) {
                    case 'BankVerificationStatus':
                        this.accountVerificationForm.patchValue({ accountStatusMode: parseInt(item.value) == 1 ? true : false })
                        break;
                    case 'LoadsheddingModeStatus':
                        // vm.loadSheddingMode = parseInt(item.value) == 1 ? true : false;
                        break;
                }
            });
        });
    }
    restrictSpace(event: KeyboardEvent): void {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }
    getminyears() {
        let nowInMs = new Date().getTime();
        let majorAge = 1000 * 60 * 60 * 24 * 365 * 18;
        let minAge = 1000 * 60 * 60 * 24 * 365 * 150;
        let diffyearMax = new Date(nowInMs - majorAge);
        let diffyearMin = new Date(nowInMs - minAge);
        this.maxDate = (diffyearMax);
        this.minDate = (diffyearMin);
    }

    initForm() {
        this.form = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            application: ["", [Validators.required]],
            referenceNumber: ["", [Validators.required]]
        });

        this.customerDetails = this._formBuilder.group({
            refrenceNumber: [''],
            firstName: ['', [Validators.required, Validators.pattern(/\S/)]],
            lastName: ['', [Validators.required, Validators.pattern(/\S/)]],
            email: ['', [Validators.required, Validators.email]],
            dateOfBirth: ["", [Validators.required]],
            identificationNumber: ['', [Validators.required]],
            mobileNumberLabel: [{ value: null, disabled: true, }],
            mobileNumber: ['', [Validators.required]],
            landLineNumberlabel: [{ value: null, disabled: true, }],
            landLineNumber: [''],
        });

        this.amendAddressForm = this._formBuilder.group({
            addressLine1: ['',],
            addressLine2: ['',],
            city: ['', [Validators.required, Validators.pattern(/\S/)]],
            region: ['', [Validators.required, Validators.pattern(/\S/)]],
        });

        this.accountVerificationForm = this._formBuilder.group({
            BankCode: ['', [Validators.required]],
            accountStatusMode: [false, [Validators.required]],
            BranchCode: ['', [Validators.required, Validators.pattern(/\S/)]],
            AccountNumber: ['', [Validators.required, Validators.pattern(/\S/)]],
            AccountType: ['', [Validators.required, Validators.pattern(/\S/)]],
        });

        this.billingInfoFormGroup = this._formBuilder.group({
            id: [0],
            address1: ['', Validators.required],
            address2: [''],
            address3: [''],
            mailingCity: [''],
            mailingState: [''],
            mailingPostCode: [''],
            mailingCountry: [''],
            vatNumber: [''],
            delivery1: ['', Validators.required],
            delivery2: [''],
            delivery3: [''],
            deliveryCity: [''],
            deliveryState: [''],
            deliveryPostCode: [''],
            deliveryCountry: [''],
            contact: ['', Validators.required],
            contactCell27: [''],
            contactCell: ['', Validators.required],
            eMail: ['', Validators.required],
            role: ['', Validators.required],
            contact2: [''],
            contactCell227: [''],
            contactCell2: [''],
            eMail2: [''],
            role2: [''],
            canDelete: [''],
            code: [''],
            creationTs: [''],
            creationUserId: [''],
            isAddOrModify: [''],
            isDirty: [''],
            isNewRecord: [''],
            isValid: [''],
            lastChangeTs: [''],
            lastChangeUserId: [''],
            state: [''],
            statusType: [''],
            userId: [''],
            customerName: ['']
        });
    }

    onInputChangeLandLineNo(controllerName: any) {
        if (this.customerDetails.get(controllerName).value.startsWith('0')) {
            this.customerDetails.controls[controllerName].setValue(this.customerDetails.get(controllerName).value.slice(1));
        }
    }
    lencondition(controllerName: any) {
        if (this.customerDetails.get(controllerName).value.length < 9) {
            this.customerDetails.controls[controllerName].setErrors({ required: true })
        }
    }
    onInputChangeLandLineNoB(controllerName: any) {
        if (this.billingInfoFormGroup.get(controllerName).value.startsWith('0')) {
            this.billingInfoFormGroup.controls[controllerName].setValue(this.billingInfoFormGroup.get(controllerName).value.slice(1));
        }
    }

    onInput(event: any, regexPattern: any): void {
        this.InputformatService.isNumericOrHyphenOrSpace(event, regexPattern);
    }

    onlyNumberKey(event) {
        return event.charCode == 8 || event.charCode == 0
            ? null
            : event.charCode >= 48 && event.charCode <= 57;
    }

    goToHomeConnectUser() {
        this.navigationService.goToHomeConnectUser();
    }
    searchbyemail() {
        if (this.form.controls["email"].valid) {
            this.UserdataService.getAmendCustomer(this.form.value.email).subscribe(res => {
                if (res) {
                    // if (res.roleId == 1 || res.roleId == 2 || res.roleId == 6
                    //     || res.roleId == 8 || res.roleId == 9) 
                    if (res.roleId != 3 && res.roleId != 5) {

                        Swal.fire({
                            text: "Admin User details can be updated from the Home Connect Login. Click OK to proceed ",
                            icon: "info",
                            confirmButtonText: "OK",
                            allowOutsideClick: true
                        }).then((result) => {

                            if (result.isConfirmed) {
                                this.goToHomeConnectUser();
                            }

                        });
                    }
                    if(res.roleId == 3 || res.roleId == 5){ 
                        this.customerDetails.patchValue({
                            ...res,
                            mobileNumber: res.mobileNumber.replace("+27", ""),
                            landLineNumber: res.landLineNumber ? res.landLineNumber.replace("+27", "") : res.landLineNumber
                        })
                        this.amendcustomer = true;
                        this.cusdetails = res;
                    }
                } else {
                    this.toastr.showError("Please enter valid email address");
                }
            });

        } else {
            this.toastr.showError("Please enter valid email address");
        }
    }

    refreshCustomer() {
        this.amendcustomer = false;
        this.amendaddress = false;
        this.billlingInformation = false;
        this.form.reset();
        this.customerDetails.reset();
        this.amendAddressForm.reset();
        this.billingInfoFormGroup.reset();
    }

    submitAmendCustomer() {
        if (this.customerDetails.valid) {
            // let payload = {
            //     ...this.customerDetails.value,
            //     mobilenumber: '+27' + this.customerDetails.value.mobileNumber,
            //     PrimaryContactNumber: '+27' + this.customerDetails.value.mobileNumber,
            //     currentEmail: this.cusdetails.email,
            //     landLineNumber: this.customerDetails.value.landLineNumber ? '+27' + this.customerDetails.value.landLineNumber : this.customerDetails.value.landLineNumber

            // }
            let formValues = this.customerDetails.value;

            let payload: any = {
                mobilenumber: '+27' + formValues.mobileNumber,
                PrimaryContactNumber: '+27' + formValues.mobileNumber,
                landLineNumber: formValues.landLineNumber ? '+27' + formValues.landLineNumber : null,
                ...Object.keys(formValues).reduce((acc, key) => {
                    acc[key] = formValues[key] === this.cusdetails[key] ? null : formValues[key];
                    return acc;
                }, {})
            };
            payload.userId = this.cusdetails.id;
            // if(this.cusdetails.email.toLowerCase().trim()==this.customerDetails.value.email.toLowerCase().trim()){
            //     payload.currentEmail=null
            // }
            this.UserdataService.submitAmendCustomer(payload).subscribe({
                next: (res: any) => {
                    if (res === "Customer updated successfully") {
                        Swal.fire("Success!", res, "success").then(() => {
                            this.refreshCustomer();
                        });
                    }
                    else if (res === "No changes detected") {
                        Swal.fire("Your data is already up to date.");
                    }
                    else {
                        Swal.fire("Error!", res, "error");
                    }
                },
                error: (err) => {
                    Swal.fire("Error!", err.error || "Something went wrong", "error");
                }
            });

        }
        else if (this.customerDetails.value.mobileNumber.length < 9)
            this.toastr.showError("Mobile Number must be 9 Digits");

        else {
            this.customerDetails.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields!");
        }
    }

    openDatePicker() {
        this.dateOfBirthPicker.open();
    }

    onTabChange(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;
        if (this.selectedIndex === 2) {
            this.getAccountType();
        }
        this.refreshCustomer();
    }

    getAccountType() {
        this.LookupDataServiceService.getAccountType(true).subscribe(res => {
            this.AccountTypeList = res;
            this.filterAccountTypeList = this.AccountTypeList;
        })
    }

    saveAccountVerificationStatus(event) {
        let payload = {
            AccountStatusModeStatus: event.checked ? 1 : 0
        }
        this.grayLogService.saveGraylogConfiguration(payload).subscribe(res => {
            if (res) {
                this.toastr.showSuccess("Mode updated successfully!");
            }
            else {
                this.toastr.showError("Somthing went to wrong. Please try again!");
            }
        });

    }
    submitAccountVerification() {
        debugger
        if (this.accountVerificationForm.valid) {
            let payload = {
                ...this.accountVerificationForm.value,
            }
            this.grayLogService.GraylogNotificationConfiguration().subscribe((res) => {
                res.forEach(item => {
                    if (item.key == 'BankVerificationStatus') {
                        this.bankaccountmode = parseInt(item.value);
                        if (this.bankaccountmode == 1) {
                            this.submitAccountVerification1();
                        }
                        else {
                            this.toastr.showSuccess("Banking details has been verified successfully!");
                        }
                    }
                });
            });
        } else {
            this.accountVerificationForm.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields!");
        }
    }

    async submitAccountVerification1(): Promise<any> {
        try {
            const isPaySoftBank = this.BankList.find(x => x.key === this.accountVerificationForm.value.BankCode);
            if (isPaySoftBank) {
                const postData = {
                    name: isPaySoftBank.value,
                    accountNumber: this.accountVerificationForm.value.AccountNumber,
                    branchCode: this.accountVerificationForm.value.BranchCode
                };
                const result = await firstValueFrom(this.ProfileDetailService.getBankAccountVerification(postData));

                const parsedResult = result
                // const parsedResult = {
                //     ...result,
                //     isAccountExists: true,
                //      isAccountOpen: true,
                //     isAcceptsDr: true,
                //     isError: false,
                //      errorMessage: null
                // };

                if (parsedResult.isAccountExists && parsedResult.isAccountOpen && parsedResult.isAcceptsDr) {
                    await Swal.fire({
                        title: 'Success!!',
                        text: 'Banking details had been verified successfully.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then(isConfirm => {
                        if (isConfirm) {
                            this.accountVerificationForm.reset();
                        }
                    });
                    return true;
                }
                else if (parsedResult.isNoResponse) {
                    return true;
                }
                else if (parsedResult.isError) {
                    let error = "Oops! There has been an error reaching your bank to verify the details, please try again. Should the problem persist, please wait 5 minutes before retrying.";
                    if (result.errorMessage) {
                        error = "The bank account details provided could not be verified, please review the details again and correct your information.Please click on Proceed once you have made the necessary changes.";
                    }
                    Swal.fire({
                        text: error,
                        position: 'center',
                        icon: 'warning'
                    })
                    return false
                }
                // else {
                //     Swal.fire({
                //         text: result,
                //         position: 'center',
                //         icon: 'warning'
                //     })
                //     return false
                // }
                else {
                    let failedMessage = "";

                    if (!parsedResult.isAccountExists) {
                        failedMessage = "The bank account number does not exist. Please check and try again.";
                    }
                    else if (!parsedResult.isAccountOpen) {
                        failedMessage = "The bank account is not open or active. Please verify with your bank.";
                    }
                    else if (!parsedResult.isAcceptsDr) {
                        failedMessage = "Debit transactions are blocked for this bank account.";
                    }
                    else {
                        failedMessage = "Unable to verify bank details. Please review and try again.";
                    }

                    Swal.fire({
                        text: failedMessage,
                        position: 'center',
                        icon: 'warning'
                    });

                    return false;
                }

            }
        }
        catch (error) {
            const errorMsg = " Oops! There has been an error reaching your bank to verify the details, please try again. Should the problem persist, please wait 5 minutes before retrying.";
            Swal.fire({
                text: errorMsg,
                position: 'center',
                icon: 'warning'
            })
            return false
        }
    }

    goToManageService() {
        this.navigationService.goToManageService();
    }

    resetPassword() {
        const title = 'Confirmation';
        const txt = 'Are you sure you want to change your password?';
        const Yes = 'Yes';
        const No = 'No';
        Swal.fire({
            title,
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.UserdataService.resetPasswordForAmendCustomer(this.form.value.email, false).subscribe((res) => {
                    if (res) {
                        Swal.fire("Success!", "Password Changed Successfully", "success").then(() => {
                            this.refreshCustomer();
                        })
                    }
                });
            }
        });
    }

    clearBalance() {
        const title = 'Confirmation';
        const txt = 'Are you sure you want to clear the balance?';
        const Yes = 'Yes';
        const No = 'No';
        Swal.fire({
            title,
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.UserdataService.clearBalanceForAmendCustomer(this.form.value.email, this.customerDetails.value.refrenceNumber).subscribe((res) => {
                    if (res) {
                        Swal.fire("Success!", "Balance Cleared Successfully", "success").then(() => {
                            this.refreshCustomer();
                        })
                    }
                });
            }
        });

    }

    searchbyapplication() {
        if (this.form.controls["application"].valid) {
            this.UserdataService.getAmendAddress(this.form.value.application).subscribe(res => {
                if (res) {
                    this.amendAddressForm.patchValue({
                        ...res
                    })
                    this.amendaddress = true;
                } else {
                    this.toastr.showError("Please enter valid application number");
                }
            });

        } else {
            this.toastr.showError("Please enter application number to search");
        }
    }

    submitAmendAddress() {
        if (this.amendAddressForm.valid) {
            let payload = {
                ...this.amendAddressForm.value,
                applicationReferenceNumber: this.form.value.application
            }
            this.UserdataService.submitAmendAddress(payload).subscribe((res) => {
                if (res) {
                    Swal.fire("Success!", "Address Updated Successfully", "success").then(() => {
                        this.refreshCustomer();
                    })
                }
            });
        } else {
            this.amendAddressForm.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields!");
        }
    }

    searchBillingInformation() {
        if (this.form.controls["referenceNumber"].valid) {
            this.UserdataService.getAmendBillingInformation(this.form.value.referenceNumber).subscribe(res => {
                if (res) {
                    this.getMailList();
                    this.getBillingRole();
                    if (res.contactCell) {
                        res.contactCell = res.contactCell.slice(3);
                    }
                    if (res.contactCell2) {
                        res.contactCell2 = res.contactCell2.slice(3);
                    }
                    this.billingInfoFormGroup.patchValue({
                        ...res
                    })
                    this.billlingInformation = true;
                } else {
                    this.toastr.showError("Please enter valid reference number");
                }
            });
        } else {
            this.toastr.showError("Please enter reference number to search");
        }
    }

    getMailList() {
        this._billingService.getMailingStateType().subscribe(res => {
            this.mail = res;
            this.filteredList = this.mail.slice();
        })
    }

    getBillingRole() {
        this._billingService.getBillingRoleType().subscribe(res => {
            this.roll = res;
            this.filteredList2 = this.roll.slice();
        })
    }

    setToDelivery() {
        this.move = !this.move;
        let addressArray = ['address1', 'address2', 'address3', 'mailingCity', 'mailingState', 'mailingPostCode'];
        let deliveryArray = ['delivery1', 'delivery2', 'delivery3', 'deliveryCity', 'deliveryState', 'deliveryPostCode'];

        addressArray.forEach((a, index) => {
            if (this.move) {
                if (this.billingInfoFormGroup.value[a]) {
                    this.billingInfoFormGroup.controls[deliveryArray[index]].setValue(this.billingInfoFormGroup.value[a]);
                }
            } else {
                this.billingInfoFormGroup.controls[deliveryArray[index]].setValue(null);
            }
        });
    }

    submitUserBilling() {
        if (this.billingInfoFormGroup.valid) {
            let modifiedRes = { ...this.billingInfoFormGroup.value };
            if (this.billingInfoFormGroup.value.contactCell) {
                modifiedRes.contactCell = '+27' + this.billingInfoFormGroup.value.contactCell;
            }
            if (this.billingInfoFormGroup.value.contactCell2) {
                modifiedRes.contactCell2 = '+27' + this.billingInfoFormGroup.value.contactCell2;
            }
            this._billingService.submitUserBilling(modifiedRes).subscribe((res) => {
                if (res == "true") {
                    Swal.fire("Success!", "Updated Successfully", "success").then(() => {
                        this.refreshCustomer();
                    })
                } else {
                    Swal.fire("Oops!!", res, "error").then(() => {
                        this.refreshCustomer();
                    })
                }
            });
        } else {
            this.billingInfoFormGroup.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields!");
        }
    }

    onTechNameChange(e) {
        if (this.accountVerificationForm.value.BankCode) {
            let bankdetail = this.BankList.filter((res: any) => { return e.value == res.key });
            this.accountVerificationForm.patchValue({
                BranchCode: bankdetail[0].key
            })
        }
        else {
            this.accountVerificationForm.patchValue({
                BranchCode: ''
            })
        }

    }

}
